import {ComponentType}                              from '@angular/cdk/portal';
import {Injectable}                                 from '@angular/core';
import {GlobalRecordType, GlobalRecordTypeMaps}     from '@djsharkk/logr-types';
import {v4 as uuidv4}                               from 'uuid';
import {TableRowBase}                               from './table-row-base';
import {TableRowBodyComponent}                      from './table-row-body/table-row-body.component';
import {TableRowCaffComponent}                      from './table-row-caff/table-row-caff.component';
import {TableRowFoodComponent}                      from './table-row-food/table-row-food.component';
import {TableRowHkitComponent}                      from './table-row-hkit/table-row-hkit.component';
import {TableRowMedsComponent}                      from './table-row-meds/table-row-meds.component';
import {TableRowMindComponent}                      from './table-row-mind/table-row-mind.component';
import {TableRowMoodComponent}                      from './table-row-mood/table-row-mood.component';
import {TableRowOuraSleepComponent}                 from './table-row-oura-sleep/table-row-oura-sleep.component';
import {TableRowVapeComponent}                      from './table-row-vape/table-row-vape.component';
import {TableLogRecordDate, TableLogType, TableRow} from './table-wrapper/table-wrapper.component';

@Injectable({
				providedIn: 'root'
			})
export class TableToolsService {

	recordsDateKey: TableLogRecordDate<Date> = {
		heart: (record) => record.timestamp,
		sleep: (record) => record.bedtime_end,
		vape : (record) => record.timestamp.toDate(),
		meds : (record) => record.timestamp.toDate(),
		mood : (record) => record.timestamp.toDate(),
		mind: (record) => record.timestamp.toDate(),
		body: (record) => record.timestamp.toDate(),
		caff: (record) => record.timestamp.toDate(),
		food: (record) => record.timestamp.toDate(),
		// hkit : (record) => record.timestamp.toDate()
		blood_oxygen_saturation     : (record) => record.timestamp.toDate(),
		environmental_audio_exposure: (record) => record.timestamp.toDate(),
		handwashing                 : (record) => record.timestamp.toDate(),
		headphone_audio_exposure    : (record) => record.timestamp.toDate(),
		respiratory_rate            : (record) => record.timestamp.toDate(),
		toothbrushing               : (record) => record.timestamp.toDate(),
		weight_body_mass            : (record) => record.timestamp.toDate(),
		dietary_water               : (record) => record.timestamp.toDate()
	}

	rowComps: { [key in Partial<(GlobalRecordType | 'hkit')>]: ComponentType<TableRowBase<any>> | undefined } = {
		vape                        : TableRowVapeComponent,
		meds                        : TableRowMedsComponent,
		mood                        : TableRowMoodComponent,
		mind            : TableRowMindComponent,
		body            : TableRowBodyComponent,
		caff            : TableRowCaffComponent,
		food            : TableRowFoodComponent,
		hkit            : TableRowHkitComponent,
		sleep                       : TableRowOuraSleepComponent,
		heart                       : undefined,
		heart_alert                 : undefined,
		workout                     : undefined,
		blood_oxygen_saturation     : TableRowHkitComponent,
		environmental_audio_exposure: TableRowHkitComponent,
		handwashing                 : TableRowHkitComponent,
		headphone_audio_exposure    : TableRowHkitComponent,
		respiratory_rate            : TableRowHkitComponent,
		toothbrushing               : TableRowHkitComponent,
		weight_body_mass            : TableRowHkitComponent,
		dietary_water               : TableRowHkitComponent,
		active_energy               : undefined,
		apple_exercise_time         : undefined,
		apple_stand_time            : undefined,
		step_count                  : undefined,
		basal_energy_burned         : undefined,
		time_in_daylight: undefined,
		rize            : undefined
	}

	buildTableRows<T extends TableLogType>(records: GlobalRecordTypeMaps[T][], type: TableLogType): TableRow[] {
		return records.map(record => (
			this.buildTableRow(record, type)
		)).sort((a, b) => a.date.getTime() < b.date.getTime() ? 1 : -1)
	}

	buildTableRow<T extends TableLogType>(record: GlobalRecordTypeMaps[T], type: TableLogType): TableRow {
		const date = this.findDateKey(type, record);
		return {
			uuid: `${record.id}-${date.toISOString()}` || uuidv4(),
			type,
			data: record as GlobalRecordTypeMaps[typeof type],
			date
		}
	}

	findDateKey<T extends TableLogType>(type: T, record: GlobalRecordTypeMaps[T]): Date {
		return this.recordsDateKey[type](record);
	}
}
